export const HIGH_CONFIDENCE_AUTO_ASSOCIATE_THRESHOLD = 80
export const LOW_CONFIDENCE_FILTER_THRESHOLD = 20
export const MAX_VENDOR_SUGGESTIONS = 5

export const CONFIDENCE_SCORES = {
    NAME: 50,
    IBAN: 100,
    EMAIL: 50,
    NAME_SIMILARITY_SCALE: 40,
    COUNTRY_MISMATCH_PENALTY: -100,
}
